import { BaseService } from "./common/base";
import type { Integration } from "../../../../api/src/integration/entities/integration.entity";
import type { IntegrationType } from "../../../../api/dist/src/integration/integration.service";

export class IntegrationService extends BaseService<Integration> {
  constructor() {
    super("integration");
  }

  authorizationUrl(integrationType: IntegrationType) {
    return this._get(`${integrationType}/authorization-url`);
  }

  authorizationCallback(integrationType: IntegrationType, token: string) {
    return this._post(`${integrationType}/authorization-callback`, {
      token,
    });
  }

  sync(integrationId: string) {
    return this._post(`${integrationId}/sync`);
  }

  getAvailableOrganizationIntegrations(integrationType: IntegrationType): Promise<
    {
      id: string;
      organizationName: string;
      meta: any;
      managerId: string;
    }[]
  > {
    return this._get(`available-organization-integration?type=${integrationType}`);
  }

  useOrganizationIntegration(orgUserId: string, integrationType: IntegrationType) {
    return this._post("use-organization-integration", { orgUserId, type: integrationType });
  }
}
